// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module__icon___2CIxk","click":"Icon-module__click___3vgpN","disabled":"Icon-module__disabled___2FGTc","active":"Icon-module__active___1rGQT"};